import { background, color, position, transform } from "@chakra-ui/react";

export default {
    parts: [
        'largeTypo',
        'smallTypo',
        'xsTypo',
        'title',
        'fieldContainer',
        'submitButton',
        'disclaimerText',
        'downloadAppContainer',
        'downloadAppTitle',
        'downloadAppSubTitle'
    ],
    baseStyle: {
        largeTypo: {
            display: {base: 'block'},
            fontSize: {base: 'sm'},
            lineHeight: {base: '16px'},
            fontWeight: {base: 'bold'},
            textTransform: {base: 'uppercase'},
            letterSpacing: {base: 0}
        },
        smallTypo: {
            display: {base: 'block'},
            fontSize: {base: 'sm'},
            lineHeight: {base: '15px'},
            letterSpacing: {base: 0}
        },
        xsTypo: {
            display: {base: 'block'},
            fontSize: {base: 'xs'},
            lineHeight: {base: '15px'}
        },
        title: {
            marginBottom: {base: 6}
        },
        fieldContainer: {
            position: 'relative'
        },
        inputStyling: {
            fontSize: {base: 'sm', lg: 'xs'}
        },
        submitButton: {
            display: {base: 'block'},
            lineHeight: {base: '15px'},
            letterSpacing: {base: 0},
            fontSize: {base: 'sm', lg: 'xs'},
            position: 'absolute',
            top: '14px',
            right: 0,
        },
        disclaimerText: {
            color: {base: 'grey.700'},
            marginTop: {base: 2}
        },
        downloadAppContainer: {
            marginTop: {base: 6},
            padding: {base: 4, lg: 3},
            backgroundColor: {base: 'grey.200'}
        },
        downloadAppTitle: {
            marginBottom: {base: 2}
        },
        downloadAppSubTitle: {
            marginBottom: {base: 6, lg: 3}
        },
        dividerStyling: {
            borderColor: {base: 'black'},
            borderWidth: {base: '1px'},
            marginLeft: {base: 4},
            marginRight: {base: 4}
        },
        downloadAppOn: {
            color: {base: 'grey.700'}
        },
        downloadAppStores: {
            justifyContent: {base: 'space-between', lg: 'start'}
        },
        downloadAppStore: {
            fontWeight: {base: 'medium'}
        },
        downloadAppBox: {
            width: {base: '100%', lg: 'fit-content'},
            paddingTop: {base: '6px', lg: 0},
            paddingBottom: {base: '6px', lg: 0},
            marginRight: {lg: 6},
            flexWrap: {lg: 'wrap'},
            justifyContent: {base: 'start', lg: 'space-between'},
            alignItems: {base: 'center'}
        },
        logoBox: {
            width: {base: '35px'},
            height: {base: '35px'},
            backgroundColor: {base: '#E2DFDADA'},
            borderRadius: {base: '100%'},
            justifyContent: {base: 'center'},
            alignItems: {base: 'center'},
            marginLeft: {base: 6, lg: 0}
        },
        appleLogo: {
            width: {base: '16px'},
            height: {base: '16px'}
        },
        androidLogo: {
            width: {base: '20px'},
            height: {base: '20px'}
        },
        logoQR: {
            width: {base: '76px'},
            height: {base: '76px'},
            marginRight: {lg: 2}
        },
        fieldError: {
            color: {base: 'red.600'},
            fontSize: {base: 'sm'},
            marginTop: {base: 2}
        },
        checkMarkIcon: {
            width: {base: '20px'},
            height: {base: '20px'},
            marginRight: {base: 1}
        },
        confirmationMessage: {
            alignItems: {base: 'start'},
            fontSize: {base: 'xs'},
            marginTop: {base: 6},
            marginBottom: {base: 6, lg: '86px'},
            textTransform: {base: 'uppercase'},
            fontWeight: {base: 'bold'}
        }
    }
}
